export const buildRootBackButtonUrl = () => {
  if (process.env.NODE_ENV === 'development') return '/'
  if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'prod') return 'https://www.fuseenergy.com'
  if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'test') return 'https://www.fuseenergy.dev'
  return '/'
}
